import { call, put, takeLatest } from 'redux-saga/effects';
import type { PayloadAction } from '@reduxjs/toolkit';
import axios from 'axios';
import {
  fetchSocialMediaPostsSuccess,
  fetchSocialMediaPostsFailure,
} from '../slices/socialMediaPostsSlice';

// Fetch social media posts
function* fetchSocialMediaPostsSaga(
  action: PayloadAction<string>
): Generator<any, void, any> {
  try {
    const restaurantId = action.payload;
    const url = `https://promoflowapidev.snapmenu.ai/social-media-posts/${restaurantId}`;
    
    const response = yield call(axios.get, url);
    const data = response.data;
    
    yield put(fetchSocialMediaPostsSuccess(data));
  } catch (error: any) {
    yield put(
      fetchSocialMediaPostsFailure(
        error.response?.data?.message || error.message || 'Failed to fetch social media posts'
      )
    );
  }
}

export function* socialMediaPostsSaga() {
  yield takeLatest('socialMediaPosts/fetchSocialMediaPostsRequest', fetchSocialMediaPostsSaga);
}
